import Link from '../../components/framework/link'
import { ChevronDown } from 'lucide-react'
import React from 'react'
import { Container } from '../../components/ui/container'
import { ACTIONS, PRIMARY_NAV } from '../../config/site'
import { BrandLogo } from './brand-logo'
import { AccountMenu } from './account-menu'
import { MobileNav } from './mobile-nav'

/**
 * The main header. Server-rendered apart from the drawer, which is the only
 * part that needs client behaviour.
 *
 * It is sticky on its own, below the announcement bar in normal flow: the bar
 * scrolls away and the header then settles against the top of the viewport.
 * Nothing is repositioned or measured, so there is no layout shift.
 */
export function SiteHeader() {
  return (
    <header data-site-header className="sticky top-0 z-50 border-b border-line bg-white">
      <Container>
        <div className="flex h-18 items-center justify-between gap-4 sm:gap-6">
          <BrandLogo />

          <nav aria-label="Main" className="hidden nav:block">
            <ul className="flex items-center gap-1">
              {PRIMARY_NAV.map((item) => (
                <li key={item.href}>
                  <Link href={item.href} className="nav-link">
                    {item.label}
                    {item.hasMenu ? (
                      <ChevronDown className="size-3.5 opacity-70" aria-hidden="true" />
                    ) : null}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="hidden items-center gap-2 nav:flex">
            <AccountMenu />
            <Link href={ACTIONS.listBusiness.href} className="btn-cta">
              {ACTIONS.listBusiness.label}
            </Link>
          </div>

          <MobileNav />
        </div>
      </Container>
    </header>
  )
}
